import { FloatingButton } from './FloatingButton';

export default FloatingButton;
